import * as React from 'react';

import { AttributeTableItem } from 'src/containers/ProjectDiagram/components/attributesTable/types';
import { useGenerateNewIri } from 'src/containers/ProjectDiagram/hooks/entityDrawer/useGenerateNewIri';
import { generateModelConceptIri } from 'src/containers/ProjectDiagram/utils/generateProjectIri';
import { projectSelector } from 'src/selectors/project';
import { getProjectTargetModel } from 'src/utils/getProjectTargetModel';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useCreateModelConceptAttributeFromQuery = (
  existingIris?: Set<string>
) => {
  const { projectId } = useRouterParams();
  const project = useReduxSelector(projectSelector(projectId));

  const generateNewIri = useGenerateNewIri();

  return React.useCallback(
    (query: string): AttributeTableItem => {
      const text = query.trim();

      if (!project) {
        return { text, value: '', isNewlyCreated: true, ranges: [] };
      }

      const initialValue = generateModelConceptIri(
        getProjectTargetModel(project),
        text
      );
      const value = generateNewIri(initialValue, existingIris);

      return {
        text,
        value,
        isNewlyCreated: true,
        ranges: [],
      };
    },
    [existingIris, generateNewIri, project]
  );
};
